import { EntityRepository, Repository } from "typeorm";
import { ContainerLogBook } from "../container-log-book.entity";

@EntityRepository(ContainerLogBook)
export class ContainerLogBookRepository extends Repository<ContainerLogBook> {
    
}